// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"d7e890f1","787":"f725ffc5"}[chunkId] + ".chunk.js";
};